// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__QlJOa","spinner-aib1d7":"Loader_spinner-aib1d7__k9mEn"};